import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FaceBookLeadReportService {

  constructor(private http: HttpClient) { }

  ur1 = environment.serverAPI9 + "/api/faceBookLeadReport";



  faceBookLeadReport(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.ur1}/condition${queryParams}`, requestBody);
  }

  resyncLead(leadgenId: any, pageId: any, formId: any, adGroupId: any, adId: any): Observable<any> {
    const baseUrl = environment.serverAPI2 ? environment.serverAPI2.trim() : '';
    return this.http.get(`${baseUrl}/api/catalog/lead/reterival/new/${leadgenId}/${pageId}/${formId}/${adGroupId}/${adId}`);
  }
}

